/**
 * @generated SignedSource<<2cd379b2edbde6c93b214c3cb74779af>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "collectorExternalId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "responseExternalId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "collectorExternalId",
            "variableName": "collectorExternalId"
        },
        {
            "kind": "Variable",
            "name": "responseExternalId",
            "variableName": "responseExternalId"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationPercentage",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "queryTransform",
                "value": "maxheight=46&maxwidth=40"
            }
        ],
        "kind": "ScalarField",
        "name": "url",
        "storageKey": "url(queryTransform:\"maxheight=46&maxwidth=40\")"
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SurveyResponseQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SurveyResponse",
                    "kind": "LinkedField",
                    "name": "surveyResponder_surveyResponse",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SurveyQuestion",
                            "kind": "LinkedField",
                            "name": "firstUnansweredQuestion",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Survey",
                            "kind": "LinkedField",
                            "name": "survey",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Avatar",
                                    "kind": "LinkedField",
                                    "name": "logo",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Intro_surveyResponse"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SurveyResponseQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SurveyResponse",
                    "kind": "LinkedField",
                    "name": "surveyResponder_surveyResponse",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SurveyQuestion",
                            "kind": "LinkedField",
                            "name": "firstUnansweredQuestion",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Survey",
                            "kind": "LinkedField",
                            "name": "survey",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Avatar",
                                    "kind": "LinkedField",
                                    "name": "logo",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "options",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "9b62b10b64920ec7cfb052b4ff1be136",
            "id": null,
            "metadata": {},
            "name": "SurveyResponseQuery",
            "operationKind": "query",
            "text": "query SurveyResponseQuery(\n  $collectorExternalId: Uuid!\n  $responseExternalId: String!\n) {\n  surveyResponder_surveyResponse(collectorExternalId: $collectorExternalId, responseExternalId: $responseExternalId) {\n    id\n    status\n    firstUnansweredQuestion {\n      locationPercentage\n      id\n    }\n    survey {\n      id\n      title\n      logo {\n        url(queryTransform: \"maxheight=46&maxwidth=40\")\n        id\n      }\n    }\n    ...Intro_surveyResponse\n  }\n}\n\nfragment Intro_surveyResponse on SurveyResponse {\n  firstUnansweredQuestion {\n    id\n    locationPercentage\n  }\n  survey {\n    options\n    title\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "072c58a64cd3ddd1743680bb20a61ceb";
export default node;
